import { FormGroup } from '@angular/forms';

export abstract class BaseFormComponent {
    public abstract formGroup: FormGroup;
    /** Metodo di utility per mostrare gli errori di validazione sui campi */
    public isFieldInvalid(field: string): boolean {
        return (!this.formGroup.get(field)?.valid && this.formGroup.get(field)?.touched) ?? false;
    }
}
